
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/student/enrollment",
      function () {
        return require("private-next-pages/student/enrollment/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/student/enrollment"])
      });
    }
  